import React, { useState, useEffect,useMemo, useCallback } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link, useParams, useNavigate } from "react-router-dom";
import { 
  Card, 
  Row, 
  Col, 
  Form, 
  Button, 
  Badge, 
  Modal, 
  Alert, 
  Spinner, 
  Toast, 
  ToastContainer,
  ListGroup,
  Table,
  InputGroup,
  Pagination,
} from "react-bootstrap";
import axios from "axios";
import {
  Person,
  Phone,      // ← Ajouter
  Calendar, 
  ExclamationCircle,
  Shield,
  Key,
  CheckCircle,
  XCircle,
  ArrowLeft,
  Pencil,
  Save,
  X,
  People,
  Building,
  Lock,
  Unlock,
  FileText,
  ClockHistory,
  Download,
  Eye,
  InfoCircle,
  ExclamationTriangle,
  ChevronRight,
  ChevronDown,
  Trash,
  Search,
  Plus,
  Envelope,
  Copy
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../constants/api_constants";



export default function AgentDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // États principaux
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  
  // États pour les rôles (multi-rôles)
  const [availableRoles, setAvailableRoles] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [assigningRoles, setAssigningRoles] = useState(false);
  const [removingRole, setRemovingRole] = useState(false);
  const [roleToRemove, setRoleToRemove] = useState(null);
  const [showRemoveRoleModal, setShowRemoveRoleModal] = useState(false);
  // États pour les modals

const [resetPasswordResult, setResetPasswordResult] = useState(null); // ← AJOUTEZ CETTE LIGNE
const [showPasswordModal, setShowPasswordModal] = useState(false); // ← Optionnel pour afficher le mot de passe dans un modal
  // États pour la pagination et recherche des rôles
  const [roleSearchTerm, setRoleSearchTerm] = useState('');
  const [roleCurrentPage, setRoleCurrentPage] = useState(1);
  const [roleItemsPerPage, setRoleItemsPerPage] = useState(5);
  
  // États pour les formulaires
  const [editMode, setEditMode] = useState(false);
  const [agentData, setAgentData] = useState({
    admin_lname: '',
    admin_fname: '',
    email: '',
    admin_phone: '',
    admin_fonction: '',
    admin_email: '',
    is_active: 1
  });
  
  // États pour les modals
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showTaxpayersModal, setShowTaxpayersModal] = useState(false);
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [resettingPassword, setResettingPassword] = useState(false);
  // États pour les données supplémentaires
  const [taxpayers, setTaxpayers] = useState([]);
  const [loadingTaxpayers, setLoadingTaxpayers] = useState(false);
  const [taxpayersError, setTaxpayersError] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [groupedPermissions, setGroupedPermissions] = useState({});
  const [loadingPermissions, setLoadingPermissions] = useState(false);
  
  // États pour l'expansion des groupes
  const [expandedGroups, setExpandedGroups] = useState({});
  
  // États pour les notifications
  const [notifications, setNotifications] = useState([]);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });




// États pour la pagination et recherche des contribuables
const [taxpayerSearchTerm, setTaxpayerSearchTerm] = useState('');
const [taxpayerCurrentPage, setTaxpayerCurrentPage] = useState(1);
const [taxpayerItemsPerPage, setTaxpayerItemsPerPage] = useState(10);

// Variables calculées pour la pagination
const filteredTaxpayers = useMemo(() => {
  if (!taxpayerSearchTerm) return taxpayers;
  const term = taxpayerSearchTerm.toLowerCase();
  return taxpayers.filter(t => 
    (t.nom_contribuable?.toLowerCase().includes(term)) ||
    (t.contribuable_id?.toString().includes(term)) ||
    (t.telephone?.includes(term)) ||
    (t.email?.toLowerCase().includes(term))
  );
}, [taxpayers, taxpayerSearchTerm]);

const taxpayerTotalPages = Math.ceil(filteredTaxpayers.length / taxpayerItemsPerPage);
const paginatedTaxpayers = filteredTaxpayers.slice(
  (taxpayerCurrentPage - 1) * taxpayerItemsPerPage,
  taxpayerCurrentPage * taxpayerItemsPerPage
);





  const getAuthToken = () => sessionStorage.getItem("authToken");

  const getHeaders = useCallback(() => {
    const token = getAuthToken();
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }, []);

  const hideAlert = useCallback(() => setAlertMessage({ show: false, message: '', type: 'info' }), []);
  
  const showAlert = useCallback((message, type = 'warning', duration = 5000) => {
    setAlertMessage({ show: true, message, type });
    setTimeout(() => hideAlert(), duration);
  }, [hideAlert]);

  const showNotification = (message, type = 'info', duration = 5000) => {
    const id = Date.now();
    setNotifications(prev => [{ id, message, type, show: true }, ...prev]);
    setTimeout(() => setNotifications(prev => prev.filter(n => n.id !== id)), duration);
  };

  const getScopeBadge = (scope) => {
    const colors = { global: "danger", local: "primary", super_admin: "dark" };
    return colors[scope] || "secondary";
  };

  const formatGroupName = (group) => {
    const groups = {
      general: "Général", entite: "Entités", tax: "Taxes", category: "Catégories",
      user: "Utilisateurs", usager: "Usagers", taxpayer: "Contribuables",
      reports: "Rapports", role_permission: "Rôles & Permissions", tax_collector: "Collecte de taxes"
    };
    return groups[group] || group.charAt(0).toUpperCase() + group.slice(1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Non spécifié";
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const formatDateSimple = (dateString) => {
    if (!dateString) return "Non spécifié";
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

const getStatusBadge = (isActive) => {
  // Vérifier si isActive est vrai (1 ou true ou '1')
  const isActiveBool = isActive === 1 || isActive === true || isActive === '1';
  
  const cfg = isActiveBool 
    ? { label: "Actif", color: "success", icon: <CheckCircle className="me-1" size={12} /> }
    : { label: "Inactif", color: "secondary", icon: <XCircle className="me-1" size={12} /> };
    
  return <Badge bg={cfg.color} className="d-flex align-items-center px-2 py-1">{cfg.icon}{cfg.label}</Badge>;
};

  // Charger les rôles disponibles
  const fetchAvailableRoles = useCallback(async () => {
    try {
      setLoadingRoles(true);
      const response = await axios.get(`${API_BASE_URL}/roles`, { headers: getHeaders() });
      
      let rolesData = [];
      if (Array.isArray(response.data)) rolesData = response.data;
      else if (response.data?.data && Array.isArray(response.data.data)) rolesData = response.data.data;
      
      const formattedRoles = rolesData.map(role => ({
        id: role.role_id || role.id,
        role_id: role.role_id,
        name: role.name,
        label: role.name ? role.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '',
        description: role.description || '',
        scope: role.scope || 'local'
      }));
      
      setAvailableRoles(formattedRoles);
    } catch (error) {
      console.error('Erreur fetchAvailableRoles:', error);
      showAlert(`Erreur de chargement des rôles`, 'warning');
    } finally {
      setLoadingRoles(false);
    }
  }, [getHeaders, showAlert]);

  // Charger les données de l'agent
// Charger les données de l'agent
const fetchAgentDetails = useCallback(async () => {
  try {
    setLoading(true);
    const response = await axios.get(`${API_BASE_URL}/users/${id}`, { headers: getHeaders() });

    if (response.data?.user) {
      const userData = response.data.user;
      console.log(userData);
      setAgent(userData);
      setAgentData({
        email: userData.email || '',
        is_active: userData.is_active !== undefined ? userData.is_active : 1,  // ← S'assurer que c'est bien récupéré
        admin_email: userData.admin_email || '',
        admin_lname: userData.admin_lname || '',
        admin_fname: userData.admin_fname || '',
        admin_phone: userData.admin_phone || '',
        admin_fonction: userData.admin_fonction || ''
      });
      
      // Charger les rôles de l'utilisateur
      if (userData.roles && Array.isArray(userData.roles)) {
        setUserRoles(userData.roles);
      } else if (userData.role) {
        setUserRoles([userData.role]);
      } else {
        setUserRoles([]);
      }
    } else {
      throw new Error('Format de données invalide');
    }
  } catch (error) {
    console.error('Erreur fetchAgentDetails:', error);
    setError(`Erreur de chargement des infos de l'agent`);
    showAlert(`Erreur de chargement des infos de l'agent`, 'danger');
  } finally {
    setLoading(false);
  }
}, [getHeaders, id, showAlert]);
  // Charger les permissions d'un rôle via l'API
 // Charger les permissions d'un rôle via l'API
const fetchRolePermissionsFromApi = useCallback(async (roleId) => {
  if (!roleId) return [];
  try {
    const response = await axios.get(`${API_BASE_URL}/roles/${roleId}/permissions`, { headers: getHeaders() });
    

    
    let permissionsList = [];
    if (response.data?.permissions && Array.isArray(response.data.permissions)) {
      permissionsList = response.data.permissions;
    } else if (Array.isArray(response.data)) {
      permissionsList = response.data;
    } else if (response.data?.data && Array.isArray(response.data.data)) {
      permissionsList = response.data.data;
    }
    

    
    return permissionsList.map(p => ({
      id: p.permission_id || p.id,
      name: p.name,
      display_name: p.name?.replace(/:/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || '',
      description: p.description || '',
      group: p.name?.split(':')[0] || 'general',
      action: p.name?.split(':')[1] || 'access',
      scope: p.scope || 'local'
    }));
  } catch (error) {
    console.error(`Erreur fetch permissions rôle ${roleId}:`, error.response?.data || error.message);
    return [];
  }
}, [getHeaders]);

  // Charger toutes les permissions de l'utilisateur
// Charger toutes les permissions de l'utilisateur
const fetchPermissions = useCallback(async () => {
  if (!userRoles.length) {
    setPermissions([]);
    setGroupedPermissions({});
    return;
  }
  
  try {
    setLoadingPermissions(true);
    let allPermissions = [];
    
    for (const role of userRoles) {
      const roleId = role.role_id || role.id;
      const perms = await fetchRolePermissionsFromApi(roleId);
      allPermissions = [...allPermissions, ...perms];
    }
    
    // Supprimer les doublons
    const uniquePermissions = Array.from(new Map(allPermissions.map(p => [p.id, p])).values());
    setPermissions(uniquePermissions);
    
    // Grouper les permissions par catégorie
    const grouped = uniquePermissions.reduce((acc, perm) => {
      const group = perm.group || 'general';
      if (!acc[group]) acc[group] = [];
      acc[group].push(perm);
      return acc;
    }, {});
    
    setGroupedPermissions(grouped);
    setExpandedGroups(Object.keys(grouped).reduce((acc, g) => ({ ...acc, [g]: true }), {}));
    
  
    
  } catch (error) {
    console.error('Erreur fetchPermissions:', error);
  } finally {
    setLoadingPermissions(false);
  }
}, [userRoles, fetchRolePermissionsFromApi]);
  // Charger les contribuables
  const fetchTaxpayers = useCallback(async () => {
    if (!agent?.user_id) return;
    try {
      setLoadingTaxpayers(true);
      const response = await axios.get(`${API_BASE_URL}/taxpayers`, { headers: getHeaders() });
      
      let allTaxpayers = [];
      if (response.data?.data && Array.isArray(response.data.data)) allTaxpayers = response.data.data;
      else if (Array.isArray(response.data)) allTaxpayers = response.data;

      const agentId = agent.user_id;
      const filtered = allTaxpayers.filter(t => (t.apiData?.created_by || t.created_by) && parseInt(t.apiData?.created_by || t.created_by) === agentId);
      
      setTaxpayers(filtered.map(t => ({
        id: t.id,
        contribuable_id: t.contribuable_id || t.id,
        nom_contribuable: t.nom || t.nom_contribuable || 'Non spécifié',
        email: t.email || 'Non spécifié',
        telephone: t.telephone || 'Non spécifié',
        created_at: t.apiData?.created_at || t.created_at,
        status: t.apiData?.statut || t.statut || 'inactif'
      })));
    } catch (error) {
      setTaxpayersError(error.message);
    } finally {
      setLoadingTaxpayers(false);
    }
  }, [agent, getHeaders]);

  // Filtrer les rôles disponibles
  const getFilteredAvailableRoles = () => {
    let filtered = [...availableRoles];
    if (roleSearchTerm) {
      filtered = filtered.filter(r => 
        r.label.toLowerCase().includes(roleSearchTerm.toLowerCase()) ||
        (r.description && r.description.toLowerCase().includes(roleSearchTerm.toLowerCase()))
      );
    }
    return filtered.filter(r => !userRoles.some(ur => (ur.role_id || ur.id) === r.role_id));
  };

  const getPaginatedRoles = () => {
    const filtered = getFilteredAvailableRoles();
    const start = (roleCurrentPage - 1) * roleItemsPerPage;
    return {
      items: filtered.slice(start, start + roleItemsPerPage),
      total: filtered.length,
      totalPages: Math.ceil(filtered.length / roleItemsPerPage)
    };
  };

  const changeRolePage = (page) => setRoleCurrentPage(page);
  const changeRoleItemsPerPage = (e) => {
    setRoleItemsPerPage(parseInt(e.target.value));
    setRoleCurrentPage(1);
  };
  const toggleSelectAllRoles = (select) => {
    const currentIds = getPaginatedRoles().items.map(r => r.role_id);
    if (select) {
      setSelectedRoles(prev => [...new Set([...prev, ...currentIds])]);
    } else {
      setSelectedRoles(prev => prev.filter(id => !currentIds.includes(id)));
    }
  };

  // Assigner des rôles à l'utilisateur
// Assigner des rôles à l'utilisateur - Version avec tableau role_ids
const handleAssignRoles = async () => {
  if (!agent || selectedRoles.length === 0) {
    showAlert("Veuillez sélectionner au moins un rôle", 'warning');
    return;
  }

  setAssigningRoles(true);

  try {
    // Nouveau format: { role_ids: [101, 103] }
    const payload = {
      role_ids: selectedRoles
    };
    

    
    const response = await axios.post(
      `${API_BASE_URL}/users/${agent.user_id}/roles`,
      payload,
      { headers: getHeaders() }
    );
    
    if (response.data) {
      showNotification(`${selectedRoles.length} rôle(s) assigné(s) avec succès`, 'success');
      setSelectedRoles([]);
      setRoleSearchTerm('');
      setRoleCurrentPage(1);
      await fetchAgentDetails();
      await fetchPermissions();
    } else {
      throw new Error('Erreur lors de l\'assignation');
    }
  } catch (error) {
    console.error('❌ Erreur assignation des rôles:', error.response?.data || error.message);
    showAlert(`Erreur: ${error.response?.data?.message || error.message}`, 'danger');
  } finally {
    setAssigningRoles(false);
  }
};
  // Retirer un rôle de l'utilisateur
  const handleRemoveRole = async () => {
    if (!agent || !roleToRemove) return;
    setRemovingRole(true);

    try {
      await axios.delete(`${API_BASE_URL}/users/${agent.user_id}/roles`, {
        headers: getHeaders(),
        data: { role_ids: [roleToRemove.role_id] }
      });
      showNotification('Rôle retiré avec succès', 'success');
      setShowRemoveRoleModal(false);
      setRoleToRemove(null);
      await fetchAgentDetails();
      await fetchPermissions();
    } catch (error) {
      showAlert(`Erreur: ${error.message}`, 'danger');
    } finally {
      setRemovingRole(false);
    }
  };

  // Sauvegarder les modifications
 // Sauvegarder les modifications
const handleSaveChanges = async () => {
  if (!agentData.email.trim() || !agentData.admin_lname.trim() || !agentData.admin_fname.trim()) {
    showAlert("Veuillez remplir les champs obligatoires", 'warning');
    return;
  }

  setSaving(true);
  try {
    // Ajouter is_active aux données envoyées
    const updateData = {
      email: agentData.email.trim(),
      full_name: agentData.admin_lname.trim(),
      first_name: agentData.admin_fname.trim(),
      telephone: agentData.admin_phone.trim(),
      fonction: agentData.admin_fonction.trim(),
      is_active: agentData.is_active  // ← AJOUTER CETTE LIGNE
    };
    
    await axios.put(`${API_BASE_URL}/users/${agent.user_id}`, updateData, { headers: getHeaders() });
    
    setEditMode(false);
    await fetchAgentDetails();
    showNotification('Modifications enregistrées', 'success');
  } catch (error) {
    showAlert(`Erreur: ${error.response?.data?.message || error.message}`, 'danger');
  } finally {
    setSaving(false);
  }
};

  // Changer le statut
  const [togglingStatus, setTogglingStatus] = useState(false);
  const handleToggleStatus = async () => {
    if (!agent) return;
    setTogglingStatus(true);
    const newStatus = agent.is_active === 1 ? 0 : 1;
    try {
      await axios.put(`${API_BASE_URL}/users/${agent.user_id}`, { is_active: newStatus }, { headers: getHeaders() });
      setShowStatusModal(false);
      showNotification(`Agent ${newStatus === 1 ? 'activé' : 'désactivé'}`, 'success');
      await fetchAgentDetails();
    } catch (error) {
      showAlert(`Erreur: ${error.message}`, 'danger');
    } finally {
      setTogglingStatus(false);
    }
  };

  // Réinitialiser mot de passe
// Réinitialiser mot de passe
// Réinitialiser mot de passe - Version avec modal propre
// Réinitialiser mot de passe - Version avec modal propre
const handleResetPassword = async () => {
  try {
    setResettingPassword(true);
    
    const response = await axios.post(
      `${API_BASE_URL}/users/${id}/reset-password`,
      { user_id: id },
      { headers: getHeaders() }
    );

    if (response.data && response.data.password_show) {
      // Stocker le résultat
      setResetPasswordResult(response.data);
      // Fermer le modal de confirmation
      setShowResetPasswordModal(false);
      // Ouvrir le modal d'affichage du mot de passe
      setShowPasswordModal(true);
      
      showNotification(`Mot de passe réinitialisé avec succès`, 'success');
    }
  } catch (error) {
    console.error('Erreur handleResetPassword:', error);
    showAlert(`Erreur: ${error.response?.data?.message || error.message}`, 'danger');
  } finally {
    setResettingPassword(false);
  }
};
  // Handlers
  const handleShowTaxpayers = () => { fetchTaxpayers(); setShowTaxpayersModal(true); };
  const handleShowPermissions = () => { fetchPermissions(); setShowPermissionsModal(true); };
  const handleEditToggle = () => { if (editMode) fetchAgentDetails(); setEditMode(!editMode); };

  const exportToCSV = (data, filename) => {
    if (!data?.length) { showAlert("Aucune donnée à exporter", 'warning'); return; }
    const headers = Object.keys(data[0]).join(',');
    const rows = data.map(item => Object.values(item).map(v => typeof v === 'string' ? `"${v.replace(/"/g, '""')}"` : v).join(','));
    const blob = new Blob([headers, ...rows].join('\n'), { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    URL.revokeObjectURL(link.href);
    showNotification('Export CSV réussi', 'success');
  };

  const toggleGroup = (group) => setExpandedGroups(prev => ({ ...prev, [group]: !prev[group] }));

  useEffect(() => {
    if (id) { fetchAgentDetails(); fetchAvailableRoles(); }
  }, [id, fetchAgentDetails, fetchAvailableRoles]);

  useEffect(() => {
    if (userRoles.length)
   
      fetchPermissions();
  }, [userRoles, fetchPermissions]);

  const displayFullName = `${agent?.admin_lname || ''} ${agent?.admin_fname || ''}`.trim() || agent?.full_name || 'Non spécifié';
  const displayPhone = agent?.admin_phone || agent?.telephone || 'Non spécifié';
  const displayFunction = agent?.admin_fonction || agent?.fonction || 'Non spécifié';

  if (loading) {
  return (
    <>
      <Header />
      <div className="main main-app p-3 p-lg-4" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)', minHeight: '100vh' }}>
        <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
          <div className="text-center">
            <div className="position-relative d-inline-block">
              <Spinner 
                animation="border" 
                variant="primary" 
                style={{ width: '4rem', height: '4rem' }}
              />
              <div 
                className="position-absolute top-50 start-50 translate-middle"
                style={{ width: '2rem', height: '2rem' }}
              >
                <div className="spinner-grow text-primary" style={{ width: '1rem', height: '1rem' }} />
              </div>
            </div>
            <h5 className="mt-4 fw-semibold text-primary">Chargement en cours...</h5>
            <p className="text-muted small mt-2">Veuillez patienter pendant que nous chargeons vos données</p>
            <div className="progress mt-3" style={{ width: '250px', height: '4px', margin: '0 auto' }}>
              <div 
                className="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <ToastContainer className="p-3" style={{ zIndex: 9999, position: 'fixed', top: '20px', right: '20px' }}>
          {notifications.map(n => (
            <Toast key={n.id} show={n.show} onClose={() => setNotifications(prev => prev.filter(x => x.id !== n.id))} delay={5000} autohide>
              <Toast.Header className={`bg-${n.type} text-white`}>
                {n.type === 'success' ? <CheckCircle className="me-2" /> : <InfoCircle className="me-2" />}
                <strong className="me-auto">{n.type === 'success' ? 'Succès' : 'Information'}</strong>
              </Toast.Header>
              <Toast.Body>{n.message}</Toast.Body>
            </Toast>
          ))}
        </ToastContainer>

        {alertMessage.show && (
          <div className="container-fluid mb-3">
            <Alert variant={alertMessage.type} dismissible onClose={hideAlert} className="shadow-sm border-0">
              <div className="d-flex align-items-center">
                {alertMessage.type === 'success' ? <CheckCircle className="me-2" /> :
                 alertMessage.type === 'danger' ? <XCircle className="me-2" /> :
                 <InfoCircle className="me-2" />}
                <span className="fw-medium">{alertMessage.message}</span>
              </div>
            </Alert>
          </div>
        )}

        <div className="container-fluid">
          {/* Header */}
          <Row className="mb-4">
            <Col md={12}>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div>
                  <ol className="breadcrumb fs-sm mb-1">
                    <li className="breadcrumb-item"><Link to="/superAdmin/dashboard">Tableau de bord</Link></li>
                    <li className="breadcrumb-item"><Link to="/superAdmin/Agents">Gestion des Agents</Link></li>
                    <li className="breadcrumb-item active">Détails de l'Agent</li>
                  </ol>
                  <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                    <h4 className="main-title mb-0">{displayFullName}</h4>
                    {agent && getStatusBadge(agent.is_active)}
                  </div>
                  <p className="text-muted mb-0 mt-1">
                    <Key size={12} className="me-1" /> ID: {agent?.user_id} • <Envelope className="me-1" size={12} /> {agent?.email}
                  </p>
                </div>
                <div className="d-flex gap-2 flex-wrap">
                  <Button variant="outline-secondary" onClick={() => navigate('/superAdmin/Agents')}><ArrowLeft className="me-2" />Retour</Button>
                  <Button variant="outline-primary" onClick={handleEditToggle}><Pencil className="me-2" />{editMode ? 'Annuler' : 'Modifier'}</Button>
                  <Button variant={agent?.is_active === 1 ? "outline-warning" : "outline-success"} onClick={() => setShowStatusModal(true)}>
                    {agent?.is_active === 1 ? <Lock className="me-2" /> : <Unlock className="me-2" />}
                    {agent?.is_active === 1 ? 'Désactiver' : 'Activer'}
                  </Button>
                  <Button 
  variant="outline-info" 
  onClick={() => setShowResetPasswordModal(true)}
  disabled={resettingPassword}
>
  {resettingPassword ? <Spinner size="sm" className="me-2" /> : <Key className="me-2" />}
  Réinitialiser MDP
</Button>
                
                </div>
              </div>
            </Col>
          </Row>

          <Row className="g-4">
            {/* Colonne gauche - Informations et Rôles */}
            <Col lg={8}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Header className="bg-primary text-white py-3">
                  <Card.Title className="mb-0"><Person className="me-2" />Informations de l'Agent</Card.Title>
                </Card.Header>
                <Card.Body className="p-4">
                 {editMode ? (
  <Row>
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label>Nom <span className="text-danger">*</span></Form.Label>
        <Form.Control 
          type="text" 
          value={agentData.admin_lname} 
          onChange={e => setAgentData({...agentData, admin_lname: e.target.value})} 
          required 
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label>Prénom <span className="text-danger">*</span></Form.Label>
        <Form.Control 
          type="text" 
          value={agentData.admin_fname} 
          onChange={e => setAgentData({...agentData, admin_fname: e.target.value})} 
          required 
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label>Email <span className="text-danger">*</span></Form.Label>
        <Form.Control 
          type="email" 
          value={agentData.email} 
          onChange={e => setAgentData({...agentData, email: e.target.value})} 
          required 
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label>Téléphone</Form.Label>
        <Form.Control 
          type="tel" 
          value={agentData.admin_phone} 
          onChange={e => setAgentData({...agentData, admin_phone: e.target.value})} 
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label>Fonction</Form.Label>
        <Form.Control 
          type="text" 
          value={agentData.admin_fonction} 
          onChange={e => setAgentData({...agentData, admin_fonction: e.target.value})} 
        />
      </Form.Group>
    </Col>
    <Col md={6}>
      <Form.Group className="mb-3">
        <Form.Label>Statut <span className="text-danger">*</span></Form.Label>
        <Form.Select 
          value={agentData.is_active} 
          onChange={e => setAgentData({...agentData, is_active: parseInt(e.target.value)})}
        >
          <option value={1}>Actif</option>
          <option value={0}>Inactif</option>
        </Form.Select>
        <Form.Text className="text-muted">
          Un agent inactif ne pourra pas se connecter à la plateforme
        </Form.Text>
      </Form.Group>
    </Col>
    <Col md={12}>
      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={handleEditToggle}>
          <X className="me-2" /> Annuler
        </Button>
        <Button variant="primary" onClick={handleSaveChanges} disabled={saving}>
          {saving ? <Spinner size="sm" /> : <><Save className="me-2" />Enregistrer</>}
        </Button>
      </div>
    </Col>
  </Row>
) : (
                    <Row>
                      <Col md={6}>
                        <div className="mb-3"><h6 className="text-muted mb-2">Identité</h6><p className="mb-1"><strong>Nom complet:</strong> {displayFullName}</p><p className="mb-1"><strong>Email:</strong> {agent?.email}</p><p className="mb-1"><strong>Téléphone:</strong> {displayPhone}</p><p className="mb-1"><strong>Fonction:</strong> {displayFunction}</p></div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3"><h6 className="text-muted mb-2">Statut</h6><p className="mb-1"><strong>Statut:</strong> {getStatusBadge(agent?.is_active)}</p><p className="mb-1"><strong>Dernière connexion:</strong> {agent?.last_login_at ? formatDate(agent.last_login_at) : "Jamais"}</p><p className="mb-1"><strong>Créé le:</strong> {formatDate(agent?.created_at)}</p></div>
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Card>

              {/* Carte Gestion des Rôles */}
              <Card className="border-0 shadow-sm">
                <Card.Header className="bg-warning text-white py-3">
                  <Card.Title className="mb-0"><Shield className="me-2" />Gestion des Rôles</Card.Title>
                </Card.Header>
                <Card.Body className="p-4">
                  {/* Rôles actuels */}
                  <div className="mb-4">
                    <h6 className="text-muted mb-3">Rôles actuels ({userRoles.length})</h6>
                    {userRoles.length === 0 ? (
                      <Alert variant="info" className="py-2"><InfoCircle className="me-2" />Aucun rôle assigné.</Alert>
                    ) : (
                      <div className="d-flex flex-wrap gap-2">
                        {userRoles.map(role => (
                          <Badge key={role.role_id || role.id} bg={getScopeBadge(role.scope)} className="d-flex align-items-center px-3 py-2" style={{ fontSize: '0.9rem' }}>
                            <Shield className="me-2" size={14} />
                            {role.name?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || 'Rôle'}
                            <Button variant="link" size="sm" className="text-white p-0 ms-2" onClick={() => { setRoleToRemove({ role_id: role.role_id || role.id, name: role.name }); setShowRemoveRoleModal(true); }}><X size={14} /></Button>
                          </Badge>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Assigner des rôles */}
                  <div>
                    <h6 className="text-muted mb-3">Assigner de nouveaux rôles</h6>
                    {loadingRoles ? <Spinner size="sm" /> : getFilteredAvailableRoles().length === 0 ? (
                      <Alert variant="info" className="py-2">Tous les rôles sont déjà assignés.</Alert>
                    ) : (
                      <>
                        <div className="d-flex justify-content-between mb-3 flex-wrap gap-2">
                          <div className="d-flex gap-2">
                            <Button size="sm" variant="outline-primary" onClick={() => toggleSelectAllRoles(true)}><CheckCircle className="me-1" size={14} />Tout sélectionner</Button>
                            <Button size="sm" variant="outline-secondary" onClick={() => toggleSelectAllRoles(false)}><XCircle className="me-1" size={14} />Tout désélectionner</Button>
                          </div>
                          <div className="d-flex gap-2">
                            <InputGroup style={{ width: '250px' }}><InputGroup.Text><Search size={14} /></InputGroup.Text><Form.Control type="text" placeholder="Rechercher..." value={roleSearchTerm} onChange={e => { setRoleSearchTerm(e.target.value); setRoleCurrentPage(1); }} size="sm" /></InputGroup>
                            <Form.Select size="sm" value={roleItemsPerPage} onChange={changeRoleItemsPerPage} style={{ width: 'auto' }}><option value={5}>5</option><option value={10}>10</option><option value={25}>25</option><option value={50}>50</option></Form.Select>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <Table hover size="sm" className="mb-0">
                            <thead className="table-light">
                              <tr><th style={{ width: '40px' }}><Form.Check checked={getPaginatedRoles().items.length > 0 && getPaginatedRoles().items.every(r => selectedRoles.includes(r.role_id))} onChange={e => toggleSelectAllRoles(e.target.checked)} /></th><th>Nom du rôle</th><th>Description</th><th>Scope</th></tr>
                            </thead>
                            <tbody>
                              {getPaginatedRoles().items.map(role => (
                                <tr key={role.role_id}>
                                  <td><Form.Check checked={selectedRoles.includes(role.role_id)} onChange={e => e.target.checked ? setSelectedRoles([...selectedRoles, role.role_id]) : setSelectedRoles(selectedRoles.filter(id => id !== role.role_id))} /></td>
                                  <td><strong>{role.label}</strong><br /><small className="text-muted">{role.name}</small></td>
                                  <td><small>{role.description || '-'}</small></td>
                                  <td><Badge bg={getScopeBadge(role.scope)}>{role.scope}</Badge></td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                        {getPaginatedRoles().totalPages > 1 && (
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <small className="text-muted">{((roleCurrentPage-1)*roleItemsPerPage)+1} à {Math.min(roleCurrentPage*roleItemsPerPage, getPaginatedRoles().total)} sur {getPaginatedRoles().total}</small>
                            <nav><ul className="pagination pagination-sm mb-0">{[...Array(getPaginatedRoles().totalPages)].map((_, i) => <li key={i} className={`page-item ${roleCurrentPage === i+1 ? 'active' : ''}`}><button className="page-link" onClick={() => changeRolePage(i+1)}>{i+1}</button></li>)}</ul></nav>
                          </div>
                        )}
                        <div className="mt-3 pt-2 border-top d-flex justify-content-end">
                          <Button variant="warning" onClick={handleAssignRoles} disabled={assigningRoles || selectedRoles.length === 0}>
                            {assigningRoles ? <Spinner size="sm" className="me-2" /> : <Plus className="me-2" size={14} />}
                            Assigner {selectedRoles.length} rôle(s)
                          </Button>
                        </div>
                      </>
                    )}
                  </div>

                  {/* Résumé permissions */}
                  {/* {userRoles.length > 0 && (
                    <div className="mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
                      <div><h6 className="mb-0">Permissions associées</h6><small className="text-muted">{permissions.length} permission(s) via {userRoles.length} rôle(s)</small></div>
                      <Button variant="outline-primary" size="sm" onClick={handleShowPermissions}><Eye className="me-1" size={14} />Voir</Button>
                    </div>
                  )} */}
                </Card.Body>
              </Card>
            </Col>

            {/* Colonne droite - Actions et Métadonnées */}
            <Col lg={4}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Header className="bg-info text-white py-3">
                  <Card.Title className="mb-0"><Key className="me-2" />Actions Rapides</Card.Title>
                </Card.Header>
                <Card.Body className="p-0">
                  <ListGroup variant="flush">
                    <ListGroup.Item className="d-flex justify-content-between align-items-center px-4 py-3">
                      <div><Shield className="me-2 text-primary" />Voir les permissions</div>
                      <Button size="sm" variant="outline-primary" onClick={handleShowPermissions}><Eye className="me-1" />Voir</Button>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center px-4 py-3">
                      <div><People className="me-2 text-success" />Contribuables {taxpayers.length > 0 && <Badge bg="success" className="ms-2">{taxpayers.length}</Badge>}</div>
                      <Button size="sm" variant="outline-success" onClick={handleShowTaxpayers}><Eye className="me-1" />Voir</Button>
                    </ListGroup.Item>
                  </ListGroup>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm mb-4">
                <Card.Header className="bg-secondary text-white py-3">
                  <Card.Title className="mb-0"><Building className="me-2" />Métadonnées Système</Card.Title>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="mb-3">
                    <h6 className="text-muted mb-2">Informations techniques</h6>
                    <p className="mb-1 small"><strong>ID Base:</strong> {agent?.id}</p>
                    <p className="mb-1 small"><strong>Ajouté par:</strong> {agent?.added_by || "Système"}</p>
                  </div>
                  <div>
                    <h6 className="text-muted mb-2">Dates importantes</h6>
                    <p className="mb-1 small"><strong>Création:</strong> {formatDateSimple(agent?.created_at)}</p>
                    <p className="mb-1 small"><strong>Modification:</strong> {formatDateSimple(agent?.updated_at)}</p>
                  </div>
                </Card.Body>
              </Card>




               <Card className="border-0 shadow-sm">
                <Card.Header className="bg-success text-white py-3">
                  <Card.Title className="mb-0"><Building className="me-2" /><Key className="me-2" size={16} /> Identifiants Internes</Card.Title>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="mb-3">
                    <h6 className="text-muted mb-2">Informations internes</h6><br></br>
                    <p className="mb-1 small"><strong>Matricule interne:</strong> {agent?.matricule_interne}</p>
                    <p className="mb-1 small"><strong>Code agent interne:</strong> {agent?.code_agent_interne || "Système"}</p>
                  </div>
                 
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Modals */}
        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)} centered>
          <Modal.Header closeButton><Modal.Title>{agent?.is_active === 1 ? <><Lock className="me-2" />Désactiver</> : <><Unlock className="me-2" />Activer</>}</Modal.Title></Modal.Header>
          <Modal.Body><div className="text-center"><h5>{agent?.is_active === 1 ? "Désactiver cet agent ?" : "Activer cet agent ?"}</h5><p className="text-muted">{agent?.is_active === 1 ? "L'agent ne pourra plus se connecter." : "L'agent pourra à nouveau se connecter."}</p></div></Modal.Body>
          <Modal.Footer><Button variant="secondary" onClick={() => setShowStatusModal(false)}>Annuler</Button><Button variant={agent?.is_active === 1 ? "warning" : "success"} onClick={handleToggleStatus} disabled={togglingStatus}>{togglingStatus ? <Spinner size="sm" /> : (agent?.is_active === 1 ? "Désactiver" : "Activer")}</Button></Modal.Footer>
        </Modal>

     {/* Modal de confirmation de réinitialisation */}
<Modal show={showResetPasswordModal} onHide={() => !resettingPassword && setShowResetPasswordModal(false)} centered>
  <Modal.Header closeButton className="bg-info text-white">
    <Modal.Title>
      <Key className="me-2" />
      Réinitialiser le mot de passe
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="text-center">
      <Key size={48} className="text-info mb-3" />
      <h5>Réinitialiser le mot de passe ?</h5>
      <p className="text-muted">
        Un nouveau mot de passe temporaire à 6 chiffres sera généré.
        <br />
        <strong>Ce mot de passe devra être changé lors de la prochaine connexion.</strong>
      </p>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowResetPasswordModal(false)} disabled={resettingPassword}>
      Annuler
    </Button>
    <Button variant="info" onClick={handleResetPassword} disabled={resettingPassword}>
      {resettingPassword ? <Spinner size="sm" className="me-2" /> : <Key className="me-2" />}
      {resettingPassword ? 'Réinitialisation...' : 'Réinitialiser'}
    </Button>
  </Modal.Footer>
</Modal>

      {/* Modal d'affichage du mot de passe temporaire */}
    {/* Modal d'affichage du mot de passe temporaire */}
<Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered size="lg">
  <Modal.Header closeButton className="bg-success text-white">
    <Modal.Title>
      <CheckCircle className="me-2" />
      Mot de passe réinitialisé
    </Modal.Title>
  </Modal.Header>
  <Modal.Body className="py-4">
    {/* Informations utilisateur */}
    <div className="mb-4">
      <div className="bg-light p-3 rounded-3">
        <small className="text-muted text-uppercase">Utilisateur</small>
        <h5 className="mb-0">{resetPasswordResult?.username || agent?.email}</h5>
        {resetPasswordResult?.phone && (
          <small className="text-muted d-block mt-1">
            📱 {resetPasswordResult.phone}
          </small>
        )}
      </div>
    </div>
    
    {/* Nouveau mot de passe temporaire */}
    <div className="mb-4">
      <div className="bg-warning bg-opacity-10 p-4 rounded-3 border border-warning">
        <small className="text-muted text-uppercase">Nouveau mot de passe temporaire</small>
        <div className="d-flex align-items-center justify-content-center gap-3 mt-2 flex-wrap">
          <h1 className="text-warning fw-bold mb-0" style={{ fontFamily: 'monospace', letterSpacing: '4px' }}>
            {resetPasswordResult?.password_show}
          </h1>
          <Button 
            variant="outline-warning" 
            size="sm"
            onClick={() => {
              navigator.clipboard.writeText(resetPasswordResult?.password_show);
              showNotification('Mot de passe copié dans le presse-papier', 'success');
            }}
            title="Copier le mot de passe"
          >
            <Copy className="me-1" size={14} />
            Copier
          </Button>
        </div>
      </div>
    </div>
    
    {/* Statut de l'envoi SMS */}
    <div className="mb-4">
      <h6 className="fw-semibold mb-2">
        <Shield className="me-2 text-primary" size={16} />
        Statut de l'envoi SMS
      </h6>
      
      {/* Message de succès SMS */}
      {resetPasswordResult?.sms_sent === true && (
        <Alert variant="success" className="mb-2">
          <div className="d-flex align-items-start">
            <CheckCircle className="me-2 mt-1" size={18} />
            <div>
              <strong>SMS envoyé avec succès !</strong>
              <br />
              <small>
                Un SMS contenant le nouveau mot de passe a été envoyé à {resetPasswordResult?.phone || 'l\'utilisateur'}
              </small>
              {resetPasswordResult?.sms_response && (
                <div className="mt-2 pt-2 border-top">
                  <small className="text-muted">
                    <strong>Réponse du serveur SMS :</strong><br />
                    ID: {resetPasswordResult.sms_response.sms_id || '-'}<br />
                    Statut: {resetPasswordResult.sms_response.message || 'ENVOYÉ'}<br />
                    Fournisseur: {resetPasswordResult.sms_response.provider_sms || '-'}
                  </small>
                </div>
              )}
            </div>
          </div>
        </Alert>
      )}
      
      {/* Message d'erreur SMS */}
      {resetPasswordResult?.sms_sent === false && (
        <Alert variant="warning" className="mb-2">
          <div className="d-flex align-items-start">
            <ExclamationCircle className="me-2 mt-1" size={18} />
            <div>
              <strong>Attention - SMS non envoyé</strong>
              <br />
              <small>
                {resetPasswordResult?.sms_error || 'Erreur lors de l\'envoi du SMS. Vérifiez le numéro de téléphone.'}
              </small>
              <div className="mt-2 pt-2 border-top">
                <small className="text-muted">
                  <strong>Le mot de passe a bien été réinitialisé mais n'a pas pu être envoyé par SMS.</strong><br />
                  Veuillez communiquer le mot de passe manuellement à l'utilisateur.
                </small>
              </div>
            </div>
          </div>
        </Alert>
      )}
      
      {/* Aucune information SMS */}
      {resetPasswordResult?.sms_sent === undefined && (
        <Alert variant="info" className="mb-2">
          <div className="d-flex align-items-start">
            <InfoCircle className="me-2 mt-1" size={18} />
            <div>
              <strong>Informations SMS</strong>
              <br />
              <small>Le mot de passe a été réinitialisé. Assurez-vous de le communiquer à l'utilisateur.</small>
            </div>
          </div>
        </Alert>
      )}
    </div>
    
    {/* Message important */}
    <Alert variant="info" className="mt-2 text-start">
      <InfoCircle className="me-2" />
      <strong>Information importante :</strong><br />
      Ce mot de passe est temporaire. L'utilisateur devra le changer lors de sa prochaine connexion.
      <hr className="my-2" />
      <small>ID: {resetPasswordResult?.user_id || agent?.user_id}</small>
    </Alert>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>
      Fermer
    </Button>
    <Button 
      variant="success" 
      onClick={() => {
        navigator.clipboard.writeText(resetPasswordResult?.password_show);
        showNotification('Mot de passe copié dans le presse-papier', 'success');
        setShowPasswordModal(false);
      }}
    >
      <Copy className="me-2" />
      Copier et fermer
    </Button>
  </Modal.Footer>
</Modal>


        <Modal show={showRemoveRoleModal} onHide={() => setShowRemoveRoleModal(false)} centered>
          <Modal.Header closeButton className="bg-danger text-white"><Modal.Title><Trash className="me-2" />Retirer le rôle</Modal.Title></Modal.Header>
          <Modal.Body><div className="text-center"><ExclamationTriangle size={48} className="text-danger mb-3" /><h5>Confirmer le retrait ?</h5><p>L'utilisateur perdra les permissions associées.</p></div></Modal.Body>
          <Modal.Footer><Button variant="secondary" onClick={() => setShowRemoveRoleModal(false)}>Annuler</Button><Button variant="danger" onClick={handleRemoveRole} disabled={removingRole}>{removingRole ? <Spinner size="sm" /> : "Retirer"}</Button></Modal.Footer>
        </Modal>

        <Modal show={showTaxpayersModal} onHide={() => setShowTaxpayersModal(false)} size="xl" centered>
  <Modal.Header closeButton className="bg-success text-white border-0">
    <Modal.Title className="d-flex align-items-center gap-2">
      <People size={22} />
      <span>Contribuables</span>
      <Badge bg="light" text="dark" className="ms-2 rounded-pill">
        {filteredTaxpayers.length}
      </Badge>
    </Modal.Title>
  </Modal.Header>
  
  <Modal.Body className="p-0">
    {/* Barre de recherche */}
    <div className="p-3 border-bottom bg-light">
      <InputGroup>
        <InputGroup.Text className="bg-white border-end-0">
          <Search size={18} className="text-primary" />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Rechercher par nom, ID, téléphone..."
          value={taxpayerSearchTerm}
          onChange={(e) => {
            setTaxpayerSearchTerm(e.target.value);
            setTaxpayerCurrentPage(1);
          }}
          className="border-start-0"
        />
        {taxpayerSearchTerm && (
          <Button 
            variant="outline-secondary" 
            onClick={() => {
              setTaxpayerSearchTerm('');
              setTaxpayerCurrentPage(1);
            }}
          >
            <X size={16} />
          </Button>
        )}
      </InputGroup>
    </div>

    {/* Tableau */}
    {loadingTaxpayers ? (
      <div className="text-center py-5">
        <Spinner animation="border" variant="success" />
        <p className="mt-3 text-muted">Chargement des contribuables...</p>
      </div>
    ) : filteredTaxpayers.length === 0 ? (
      <div className="text-center py-5">
        <People size={48} className="text-muted mb-3 opacity-50" />
        <p className="text-muted">Aucun contribuable trouvé</p>
        {taxpayerSearchTerm && (
          <Button variant="link" size="sm" onClick={() => {
            setTaxpayerSearchTerm('');
            setTaxpayerCurrentPage(1);
          }} className="text-decoration-none">
            Effacer la recherche
          </Button>
        )}
      </div>
    ) : (
      <>
        <div className="table-responsive">
          <Table hover className="mb-0">
            <thead className="bg-light">
              <tr>
                <th style={{ width: '100px' }}>ID</th>
                <th>Nom</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th style={{ width: '110px' }}>Date</th>
                <th style={{ width: '90px' }}>Statut</th>
              </tr>
            </thead>
            <tbody>
              {paginatedTaxpayers.map((t, index) => (
                <tr key={t.id} className="align-middle">
                  <td>
                    <Badge bg="secondary" className="fw-normal px-2 py-1">
                      {t.contribuable_id}
                    </Badge>
                  </td>
                  <td>
                    <div className="fw-semibold">{t.nom_contribuable}</div>
                    {t.activite_contribuable && (
                      <small className="text-muted">{t.activite_contribuable}</small>
                    )}
                  </td>
                  <td>
                    {t.email ? (
                      <div className="d-flex align-items-center gap-1">
                        <Envelope size={12} className="text-muted" />
                        <span className="small">{t.email}</span>
                      </div>
                    ) : '-'}
                  </td>
                  <td>
                    {t.telephone ? (
                      <div className="d-flex align-items-center gap-1">
                        <Phone size={12} className="text-muted" />
                        <span>{t.telephone}</span>
                      </div>
                    ) : '-'}
                  </td>
                  <td className="text-muted small">
                    <Calendar size={12} className="me-1" />
                    {formatDateSimple(t.created_at)}
                  </td>
                  <td>
                    <Badge 
                      bg={t.status === 'actif' || t.status === 'ACTIVE' ? 'success' : 
                          t.status === 'inactif' || t.status === 'INACTIVE' ? 'warning' : 
                          t.status === 'supprimé' || t.status === 'DESABLED' ? 'danger' : 'secondary'}
                      className="px-2 py-1 rounded-pill"
                    >
                      {t.status === 'actif' || t.status === 'ACTIVE' ? 'Actif' :
                       t.status === 'inactif' || t.status === 'INACTIVE' ? 'Inactif' :
                       t.status === 'supprimé' || t.status === 'DESABLED' ? 'Supprimé' : t.status}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* Pagination */}
        {taxpayerTotalPages > 1 && (
          <div className="p-3 border-top d-flex justify-content-between align-items-center flex-wrap gap-3 bg-light">
            <div className="text-muted small">
              Affichage de {(taxpayerCurrentPage - 1) * taxpayerItemsPerPage + 1} à{' '}
              {Math.min(taxpayerCurrentPage * taxpayerItemsPerPage, filteredTaxpayers.length)} sur{' '}
              {filteredTaxpayers.length} contribuable(s)
            </div>
            <div className="d-flex align-items-center gap-2">
              <Form.Select
                size="sm"
                value={taxpayerItemsPerPage}
                onChange={(e) => {
                  setTaxpayerItemsPerPage(Number(e.target.value));
                  setTaxpayerCurrentPage(1);
                }}
                style={{ width: '80px' }}
                className="rounded-3"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </Form.Select>
              <span className="text-muted small">par page</span>
            </div>
            <Pagination className="mb-0">
              <Pagination.First 
                disabled={taxpayerCurrentPage === 1} 
                onClick={() => setTaxpayerCurrentPage(1)}
                className="rounded"
              />
              <Pagination.Prev 
                disabled={taxpayerCurrentPage === 1} 
                onClick={() => setTaxpayerCurrentPage(p => p - 1)}
                className="rounded"
              />
              
              {(() => {
                const pages = [];
                const maxVisible = 5;
                let start = Math.max(1, taxpayerCurrentPage - Math.floor(maxVisible / 2));
                let end = Math.min(taxpayerTotalPages, start + maxVisible - 1);
                
                if (end - start + 1 < maxVisible) {
                  start = Math.max(1, end - maxVisible + 1);
                }
                
                if (start > 1) {
                  pages.push(
                    <Pagination.Item key={1} onClick={() => setTaxpayerCurrentPage(1)} className="rounded">
                      1
                    </Pagination.Item>
                  );
                  if (start > 2) {
                    pages.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
                  }
                }
                
                for (let i = start; i <= end; i++) {
                  pages.push(
                    <Pagination.Item 
                      key={i} 
                      active={i === taxpayerCurrentPage} 
                      onClick={() => setTaxpayerCurrentPage(i)}
                      className="rounded"
                    >
                      {i}
                    </Pagination.Item>
                  );
                }
                
                if (end < taxpayerTotalPages) {
                  if (end < taxpayerTotalPages - 1) {
                    pages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
                  }
                  pages.push(
                    <Pagination.Item key={taxpayerTotalPages} onClick={() => setTaxpayerCurrentPage(taxpayerTotalPages)} className="rounded">
                      {taxpayerTotalPages}
                    </Pagination.Item>
                  );
                }
                
                return pages;
              })()}
              
              <Pagination.Next 
                disabled={taxpayerCurrentPage === taxpayerTotalPages} 
                onClick={() => setTaxpayerCurrentPage(p => p + 1)}
                className="rounded"
              />
              <Pagination.Last 
                disabled={taxpayerCurrentPage === taxpayerTotalPages} 
                onClick={() => setTaxpayerCurrentPage(taxpayerTotalPages)}
                className="rounded"
              />
            </Pagination>
          </div>
        )}
      </>
    )}
  </Modal.Body>
  
  <Modal.Footer className="border-0 bg-light">
    <Button variant="secondary" onClick={() => setShowTaxpayersModal(false)} className="rounded-3 px-4">
      Fermer
    </Button>
  
  </Modal.Footer>
</Modal>

        <Modal show={showPermissionsModal} onHide={() => setShowPermissionsModal(false)} size="lg" centered>
          <Modal.Header closeButton className="bg-primary text-white"><Modal.Title><Shield className="me-2" />Permissions ({permissions.length})</Modal.Title></Modal.Header>
          <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
           {loadingPermissions ? (
  <div className="d-flex flex-column justify-content-center align-items-center py-5">
    <div className="position-relative">
      <Spinner 
        animation="border" 
        variant="primary" 
        style={{ width: '3rem', height: '3rem' }}
      />
      <div 
        className="position-absolute top-50 start-50 translate-middle"
        style={{ width: '2rem', height: '2rem' }}
      >
        <Shield className="text-primary opacity-50" size={24} />
      </div>
    </div>
    <p className="mt-3 text-muted fw-medium">Chargement des permissions...</p>
    <div className="progress mt-2" style={{ width: '200px', height: '4px' }}>
      <div 
        className="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
        style={{ width: '100%' }}
      />
    </div>
  </div>
) : permissions.length === 0 ? (
  <div className="text-center py-5">
    <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '80px', height: '80px' }}>
      <Shield size={40} className="text-muted opacity-50" />
    </div>
    <h6 className="fw-semibold mb-2">Aucune permission</h6>
    <p className="text-muted small mb-0">Cet utilisateur n'a aucune permission associée.</p>
    {userRoles.length > 0 && (
      <div className="mt-3">
        <Badge bg="secondary" className="me-1">Rôles: {userRoles.map(r => r.name).join(', ')}</Badge>
      </div>
    )}
  </div>
) : (
  Object.entries(groupedPermissions).map(([group, perms]) => (
    <Card key={group} className="mb-3 border shadow-sm">
      <Card.Header 
        className="bg-light py-3 d-flex justify-content-between align-items-center" 
        style={{ cursor: 'pointer' }} 
        onClick={() => toggleGroup(group)}
      >
        <div className="d-flex align-items-center">
          {expandedGroups[group] ? (
            <ChevronDown className="me-2 text-primary" size={18} />
          ) : (
            <ChevronRight className="me-2 text-secondary" size={18} />
          )}
          <strong className="text-dark">{formatGroupName(group)}</strong>
          <Badge bg="primary" className="ms-2 rounded-pill">{perms.length}</Badge>
        </div>
        <small className="text-muted">
          {expandedGroups[group] ? 'Réduire' : 'Développer'}
        </small>
      </Card.Header>
      {expandedGroups[group] && (
        <Card.Body className="p-3">
          <Row className="g-3">
            {perms.map(p => (
              <Col md={6} lg={4} key={p.id}>
                <Card className="border h-100 shadow-sm hover-shadow transition-all">
                  <Card.Body className="p-3">
                    <div className="d-flex align-items-start mb-2">
                      <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-2">
                        <Shield className="text-primary" size={16} />
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="fw-semibold mb-1">{p.display_name}</h6>
                        {p.description && (
                          <p className="text-muted small mb-2">{p.description}</p>
                        )}
                        <div className="d-flex flex-wrap gap-1 mt-2">
                          <Badge bg="info" className="rounded-pill px-2 py-1">
                            <small>{p.action}</small>
                          </Badge>
                          <Badge 
                            bg={getScopeBadge(p.scope)} 
                            className="rounded-pill px-2 py-1"
                          >
                            <small>{p.scope === 'global' ? '🌍 Global' : p.scope === 'local' ? '🏢 Local' : p.scope}</small>
                          </Badge>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Card.Body>
      )}
    </Card>
  ))
)}
          </Modal.Body>
          <Modal.Footer><Button variant="secondary" onClick={() => setShowPermissionsModal(false)}>Fermer</Button></Modal.Footer>
        </Modal>
{/* Modal d'affichage du mot de passe temporaire */}
<style>{`
.rounded-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 6px !important;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rounded-checkbox:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.rounded-checkbox:focus {
  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.25);
}

.table tbody tr:hover {
  background-color: rgba(13, 110, 253, 0.04);
  transition: background-color 0.2s ease;
}

.pagination .page-item .page-link {
  border-radius: 8px !important;
  margin: 0 2px;
}

.pagination .page-item.active .page-link {
  background-color: #198754;
  border-color: #198754;
}

 `}</style>
        <Footer />
      </div>
    </React.Fragment> 
    
  );
}